<template>
  <div
    class="checkout-builder"
    :style="builderBackground"
    :class="{ mobile: device == 'mobile' }"
  >
    <timer-container />
    <div class="checkout-content" :class="{ editing }">
      <desktop-view v-if="device == 'desktop'" />
      <mobile-view v-else-if="device == 'mobile'" />
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";

import TimerContainer from "./container/TimerContainer.vue";
import DesktopView from "./main/DesktopView.vue";
import MobileView from "./main/MobileView.vue";
export default {
  components: { DesktopView, MobileView, TimerContainer },
  computed: {
    ...mapState("checkoutBuilder", ["background", "device", "editing"]),
    builderBackground() {
      if (this.background?.image) {
        return { backgroundImage: `url(${this.background.image})` };
      }

      return { backgroundColor: this.background.color };
    }
  }
};
</script>

<style lang="scss" scoped>
.checkout-builder {
  &.mobile {
    @media screen and (min-width: 992px) {
      width: 450px;
      margin: 0 auto;
    }
  }

  .checkout-content {
    margin: 0 auto;
    padding: 8px 8px 40px;
    width: 75%;
    max-width: 100%;
    overflow: hidden;

    // &.editing {
    //   width: 750px;
    //   padding: 16px 16px 100px;
    // }

    @media screen and (max-width: 991px) {
      padding-bottom: 150px;
      width: 100%;
    }
  }

  ::v-deep img {
    width: 100%;
    max-width: 100%;
    backdrop-filter: blur(24px);
  }
}
</style>
